import React from 'react';

import i18n from 'i18n-react';

// FontAwesome
import 'config/FontAwesome';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import locales from 'config/i18n';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

import { App } from './app';
import { createRoot } from 'react-dom/client';

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        }),
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang?.langFile] ?? locales.en);
    });
    if (sessionStorage.getItem(sessionStorage.key('tt_sessionId')) !== '-1') {
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          const { email } = res;
          APIHandler.lastActive(appId, email);
          sessionStorage.setItem(sessionStorage.key('tt_sessionId'), -1);
        }
      });
    }
  });
  window.appId = appId;
});

if (window.navigator.cookieEnabled) {
  createRoot(document.getElementById('root')).render(<App />);
}
